import SinglePageAppLink from "../../../SinglePageAppLink/SinglePageAppLink";
import PropTypes from "prop-types";
import styles from "./PromoTileWrapper.css";
import productTileStyles from "../../../ProductTile/ProductTile.css";
import classNames from "classnames";

const PromoTileLink = ({ linkUrl, children }) => {
  if (linkUrl.includes("/cat/?cid=")) {
    return (
      <SinglePageAppLink
        href={linkUrl}
        className={classNames(styles.link, productTileStyles.productLink)}
      >
        {children}
      </SinglePageAppLink>
    );
  }

  return (
    <a
      href={linkUrl}
      className={classNames(styles.link, productTileStyles.productLink)}
    >
      {children}
    </a>
  );
};

PromoTileLink.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default PromoTileLink;
